// extracted by mini-css-extract-plugin
module.exports = {"WestminsterTowerOuter":"style_WestminsterTowerOuter__WVBbI","WestminsterTowerWrapper":"style_WestminsterTowerWrapper__ojmPH"};